import { configureStore, combineReducers } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import userSlice from '../slice/userSlice';
import enquireSlice from '../slice/enquireSlice';
import rootSaga from '../apis/rootSaga';

const persistConfig = {
  key: 'aristo_enquiry_admin',
  storage,
};

const rootReducer = combineReducers({
  user: userSlice,
  enquire: enquireSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);
const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);
const persistor = persistStore(store);

export { store, persistor };
